import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { GenericService } from '../../generic.service';
import { CommonModule } from '@angular/common';
import { issueListEult } from '../../../assets/data/poorResults-eult';
import { LandingService } from '../../landing-page/service/landing.service';
import { defaultLanguage } from '../../shared/constants/language.constants';
import { CrowdinService } from '../../shared/service/crowdin.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-poor-results-eult',
    imports: [CommonModule, RouterModule],
    templateUrl: './poor-results-eult.component.html',
    styleUrl: './poor-results-eult.component.scss'
})
export class PoorResultsEultComponent {
  private readonly noDebrisKeyValue = 6;
  private readonly noLimescaleKeyValue = 8;
  deviceData: any = {};
  deviceData$: any = null;

  issueName: string | undefined;
  accountNumber: string = '';
  showImagePopup: boolean = false;
  popupImages: string[] = [];
  showPopup: boolean = false;
  isDebris: boolean = false;
  isLimescale: boolean = false;
  languageDetails!: (item: any) => any;
  issueListEult: any = {};
  languageIndex: number = 0;
  translations: { [key: string]: string } = {};
  currentLanguage: string = defaultLanguage;
  languageOptions: Array<{ value: string }> = [];
  isLoadingTranslations = true;
  subs = new Subscription();

  constructor(
    private router: Router,
    private genericService: GenericService,
    private landingService: LandingService,
    private crowdinService: CrowdinService,
  ) {
    this.deviceData$ = this.genericService.deviceData.subscribe((data) => {
      if (data) {
        this.deviceData = data;
      }
    });
  }

  ngOnInit() {
    this.issueListEult = structuredClone(issueListEult);
    this.getTranslations();
    this.languageOptions = this.landingService.getLanguageOptions();
    this.subs.add(
      this.landingService.languageName$.subscribe((langName) => {
        this.currentLanguage = langName;
        this.translations = this.crowdinService.getAllTranslations();
        this.getTranslations();
      }),
    );

    this.landingService.loadTranslations(this.currentLanguage);
  }

  ngOnDestroy(): void {
    if (this.deviceData$) {
      this.deviceData$.unsubscribe();
    }
    this.subs.unsubscribe();
  }

  async languageChange(event: any) {
    const selectedLang = event.target.value;
    await this.landingService.loadTranslations(selectedLang);
    this.getTranslations();
  }

  goBack() {
    history.go(-1);
  }

  navigateToLandingPage() {
    this.landingService.navigateToHomePage();
    this.deviceData['languageSelected'] = this.currentLanguage;
    this.genericService.setLocalStorage(this.deviceData);
    this.genericService.deviceData.next(this.deviceData);
  }

  get progress() {
    const answered = this.issueListEult.filter(
      (item: { answered: any }) => item.answered,
    ).length;
    return (answered / this.issueListEult.length) * 100;
  }

  private getTranslations() {
    const name = this.currentLanguage || defaultLanguage;
    const key = name.toLowerCase();

    this.issueListEult = this.issueListEult.map((item: any) => ({
      ...item,
      translatedTitle:
        this.translations?.[item.titleKey] ??
        item?.title?.[key] ??
        item?.title?.english ??
        '',
      translatedDetails: (
        this.translations?.[item.detailsKey] ??
        item?.details?.[key] ??
        item?.details?.english ??
        ''
      ).trim(),
    }));
  }

  openPopup(item: any) {
    this.popupImages = item.images;
    this.isDebris = item?.keyValue === this.noDebrisKeyValue;
    this.isLimescale = false;
    this.showPopup = true;
  }

  openImagePopup(images: string[], item: any) {
    this.popupImages = images;
    this.isDebris = false;
    this.isLimescale = item?.keyValue === this.noLimescaleKeyValue;
    this.showImagePopup = true;
  }

  closePopup() {
    this.showPopup = false;
    this.showImagePopup = false;
  }

  answer(index: number, status: string) {
    this.issueListEult[index].status = status;
    this.issueListEult[index].answered = true;
    if (this.issueListEult[index].translatedDetails !== '') {
      this.issueListEult[index].expanded = true;
    }
  }

  toggleAccordion(index: number) {
    this.issueListEult[index].expanded = !this.issueListEult[index].expanded;
  }

  resolved() {
    this.router.navigateByUrl('thankYou');
    this.deviceData['languageSelected'] = this.currentLanguage;
    this.genericService.setLocalStorage(this.deviceData);
    this.genericService.deviceData.next(this.deviceData);
  }

  needHelp() {
    this.landingService.needHelp();
    this.deviceData['languageSelected'] = this.currentLanguage;
    this.genericService.setLocalStorage(this.deviceData);
    this.genericService.deviceData.next(this.deviceData);
  }
}
